(() => {
  const PACKS = {
    en: {
      home: "Home",
      close: "Close",
      open_menu: "Open menu",
      close_menu: "Close menu",
      login: "Login",
      account: "Account",
      cart: "Cart",
      search: "Search",
      search_ph: "Search model or SKU",
      light: "Light",
      dark: "Dark",
      color_theme: "Color theme",
      currency: "Currency",
      language: "Language",
      compare: "Compare",
      add_compare: "Add to compare",
      add_cart: "Add to cart",
      buy_now: "Buy now",
      out_of_stock: "Out of stock",
      in_stock: "In stock",
      low_stock: "Low stock",
      sale: "Sale",
      save: "Save",
      was: "Was",
      now: "Now",
      you_save: "You save",
      unavailable: "Unavailable",
      product_type: "Product type",
      brand: "Brand",
      model: "Model",
      storage: "Storage",
      sort_price: "Sort",
      price_range: "Price range",
      all_types: "All types",
      all_brands: "All brands",
      all_models: "All models",
      all_storage: "All storage",
      featured: "Featured",
      low_high: "Price: low to high",
      high_low: "Price: high to low",
      name_az: "Name: A to Z",
      name_za: "Name: Z to A",
      min: "Min",
      max: "Max",
      filter_search_ph: "Search type, brand, model, or storage",
      in_stock_only: "In stock only",
      clear: "Clear",
      no_match: "No devices match those filters.",
      matching: "Matching devices",
      similar: "Similar devices",
      your_details: "Your details",
      first_name: "First name",
      last_name: "Last name",
      phone: "Phone number",
      email: "Email",
      optional: "optional",
      home_address: "Home address for the receipt",
      need_delivery: "Do you need delivery?",
      yes: "Yes",
      no: "No",
      same_address: "Is the delivery address the same as your home address?",
      delivery_address: "Delivery address",
      same_receiver: "Is the person receiving the same as above?",
      receiver_first: "Receiver first name",
      receiver_last: "Receiver last name",
      receiver_phone: "Receiver phone number",
      delivery_date: "Delivery date",
      time_from: "Available from",
      time_to: "Available to",
      payment: "Payment method",
      cash: "Cash on delivery",
      mmg: "MMG",
      notes: "Other details or special instructions",
      notes_ph: "Optional — e.g. landmark, gate colour, preferred contact",
      complete_order: "Complete your order",
      send: "Send",
      sending: "Sending…",
      cancel: "Cancel",
      thanks_title: "Thank you for your order",
      thanks_copy: "Someone will reach out to confirm the order details.",
      ok: "OK",
      required_fields: "Please fill in the required fields.",
      time_order: "Available-to time must be later than available-from.",
      send_fail: "Could not send just now. Please try again.",
      explore: "Explore",
      all_devices: "All devices",
      compare_specs: "Compare specs",
      your_account: "Your account",
      order_history: "Order history",
      log_out: "Log out",
      create_account: "Create account",
      connect: "Connect",
      call_wa: "Call / WhatsApp",
      email_label: "Email",
      delivery: "Delivery",
      store: "Store",
      reviews: "Customers Reviews",
      about: "About Us",
      contact: "Contact",
      phones: "Phones",
      tablets: "Tablets",
      laptops: "Laptops",
      chargers: "Chargers",
      accessories: "Accessories",
      smart_watches: "Smart watches",
      ipads: "iPads",
      macbooks: "MacBooks",
      usb_cables: "USB cables",
      cases: "Cases",
      protectors: "Protectors",
      earbuds: "Earbuds",
      skip_content: "Skip to content",
      back_to_top: "Back to top",
      phone_ph: "e.g. 6484651",
      optional_ph: "Optional",
      each: "each",
      total: "Total",
      wa_kicker: "WhatsApp alerts",
      wa_heading: "Get prices first.",
      wa_text: "Join the SMART FIX WhatsApp group for early price updates, restocks, and early access to sales.",
      wa_number: "WhatsApp number",
      wa_number_ph: "WhatsApp number, e.g. 6484651",
      wa_confirm: "I confirm this is my WhatsApp number",
      wa_error: "Enter a valid Guyana WhatsApp number and tick confirm.",
      wa_join: "Join group"
    },
    es: {
      home: "Inicio",
      close: "Cerrar",
      open_menu: "Abrir menú",
      close_menu: "Cerrar menú",
      login: "Entrar",
      account: "Cuenta",
      cart: "Carrito",
      search: "Buscar",
      search_ph: "Buscar modelo o SKU",
      light: "Claro",
      dark: "Oscuro",
      color_theme: "Tema de color",
      currency: "Moneda",
      language: "Idioma",
      compare: "Comparar",
      add_compare: "Añadir a comparar",
      add_cart: "Añadir al carrito",
      buy_now: "Comprar ahora",
      out_of_stock: "Agotado",
      in_stock: "En stock",
      low_stock: "Poco stock",
      sale: "Oferta",
      save: "Ahorras",
      was: "Antes",
      now: "Ahora",
      you_save: "Ahorras",
      unavailable: "No disponible",
      product_type: "Tipo de producto",
      brand: "Marca",
      model: "Modelo",
      storage: "Almacenamiento",
      sort_price: "Ordenar",
      price_range: "Rango de precio",
      all_types: "Todos los tipos",
      all_brands: "Todas las marcas",
      all_models: "Todos los modelos",
      all_storage: "Todo almacenamiento",
      featured: "Destacados",
      low_high: "Precio: menor a mayor",
      high_low: "Precio: mayor a menor",
      name_az: "Nombre: A a Z",
      name_za: "Nombre: Z a A",
      min: "Mín",
      max: "Máx",
      filter_search_ph: "Buscar tipo, marca, modelo o almacenamiento",
      in_stock_only: "Solo en stock",
      clear: "Limpiar",
      no_match: "Ningún equipo coincide con esos filtros.",
      matching: "Equipos encontrados",
      similar: "Dispositivos similares",
      your_details: "Tus datos",
      first_name: "Nombre",
      last_name: "Apellido",
      phone: "Teléfono",
      email: "Correo",
      optional: "opcional",
      home_address: "Dirección de casa para el recibo",
      need_delivery: "¿Necesitas entrega?",
      yes: "Sí",
      no: "No",
      same_address: "¿La dirección de entrega es la misma que tu casa?",
      delivery_address: "Dirección de entrega",
      same_receiver: "¿Quien recibe es la misma persona?",
      receiver_first: "Nombre de quien recibe",
      receiver_last: "Apellido de quien recibe",
      receiver_phone: "Teléfono de quien recibe",
      delivery_date: "Fecha de entrega",
      time_from: "Disponible desde",
      time_to: "Disponible hasta",
      payment: "Método de pago",
      cash: "Efectivo contra entrega",
      mmg: "MMG",
      notes: "Otros detalles o instrucciones",
      notes_ph: "Opcional — punto de referencia, color del portón, contacto preferido",
      complete_order: "Completa tu pedido",
      send: "Enviar",
      sending: "Enviando…",
      cancel: "Cancelar",
      thanks_title: "Gracias por tu pedido",
      thanks_copy: "Alguien te contactará para confirmar los detalles.",
      ok: "OK",
      required_fields: "Completa los campos obligatorios.",
      time_order: "La hora hasta debe ser después de la hora desde.",
      send_fail: "No se pudo enviar. Inténtalo de nuevo.",
      explore: "Explorar",
      all_devices: "Todos los equipos",
      compare_specs: "Comparar fichas",
      your_account: "Tu cuenta",
      order_history: "Historial de pedidos",
      log_out: "Salir",
      create_account: "Crear cuenta",
      connect: "Conectar",
      call_wa: "Llamar / WhatsApp",
      email_label: "Correo",
      delivery: "Entrega",
      store: "Tienda",
      reviews: "Reseñas de clientes",
      about: "Sobre nosotros",
      contact: "Contacto",
      phones: "Teléfonos",
      tablets: "Tabletas",
      laptops: "Laptops",
      chargers: "Cargadores",
      accessories: "Accesorios",
      smart_watches: "Relojes inteligentes",
      ipads: "iPads",
      macbooks: "MacBooks",
      usb_cables: "Cables USB",
      cases: "Fundas",
      protectors: "Protectores",
      earbuds: "Audífonos",
      skip_content: "Saltar al contenido",
      back_to_top: "Volver arriba",
      phone_ph: "ej. 6484651",
      optional_ph: "Opcional",
      each: "c/u",
      total: "Total",
      wa_kicker: "Alertas de WhatsApp",
      wa_heading: "Recibe los precios primero.",
      wa_text: "Únete al grupo de WhatsApp de SMART FIX para precios anticipados, reposición y acceso temprano a las ofertas.",
      wa_number: "Número de WhatsApp",
      wa_number_ph: "Número de WhatsApp, ej. 6484651",
      wa_confirm: "Confirmo que este es mi número de WhatsApp",
      wa_error: "Ingresa un número de WhatsApp válido de Guyana y marca la confirmación.",
      wa_join: "Unirse al grupo"
    },
    pt: {
      home: "Início",
      close: "Fechar",
      open_menu: "Abrir menu",
      close_menu: "Fechar menu",
      login: "Entrar",
      account: "Conta",
      cart: "Carrinho",
      search: "Buscar",
      search_ph: "Buscar modelo ou SKU",
      light: "Claro",
      dark: "Escuro",
      color_theme: "Tema de cor",
      currency: "Moeda",
      language: "Idioma",
      compare: "Comparar",
      add_compare: "Adicionar à comparação",
      add_cart: "Adicionar ao carrinho",
      buy_now: "Comprar agora",
      out_of_stock: "Esgotado",
      in_stock: "Em estoque",
      low_stock: "Estoque baixo",
      sale: "Oferta",
      save: "Economize",
      was: "De",
      now: "Por",
      you_save: "Você economiza",
      unavailable: "Indisponível",
      product_type: "Tipo de produto",
      brand: "Marca",
      model: "Modelo",
      storage: "Armazenamento",
      sort_price: "Ordenar",
      price_range: "Faixa de preço",
      all_types: "Todos os tipos",
      all_brands: "Todas as marcas",
      all_models: "Todos os modelos",
      all_storage: "Todo armazenamento",
      featured: "Destaques",
      low_high: "Preço: menor para maior",
      high_low: "Preço: maior para menor",
      name_az: "Nome: A a Z",
      name_za: "Nome: Z a A",
      min: "Mín",
      max: "Máx",
      filter_search_ph: "Buscar tipo, marca, modelo ou armazenamento",
      in_stock_only: "Somente em estoque",
      clear: "Limpar",
      no_match: "Nenhum aparelho corresponde a esses filtros.",
      matching: "Aparelhos encontrados",
      similar: "Aparelhos semelhantes",
      your_details: "Seus dados",
      first_name: "Nome",
      last_name: "Sobrenome",
      phone: "Telefone",
      email: "E-mail",
      optional: "opcional",
      home_address: "Endereço residencial para o recibo",
      need_delivery: "Precisa de entrega?",
      yes: "Sim",
      no: "Não",
      same_address: "O endereço de entrega é o mesmo da sua casa?",
      delivery_address: "Endereço de entrega",
      same_receiver: "Quem recebe é a mesma pessoa?",
      receiver_first: "Nome de quem recebe",
      receiver_last: "Sobrenome de quem recebe",
      receiver_phone: "Telefone de quem recebe",
      delivery_date: "Data de entrega",
      time_from: "Disponível de",
      time_to: "Disponível até",
      payment: "Forma de pagamento",
      cash: "Dinheiro na entrega",
      mmg: "MMG",
      notes: "Outros detalhes ou instruções",
      notes_ph: "Opcional — ponto de referência, cor do portão, contato preferido",
      complete_order: "Conclua seu pedido",
      send: "Enviar",
      sending: "Enviando…",
      cancel: "Cancelar",
      thanks_title: "Obrigado pelo pedido",
      thanks_copy: "Alguém vai entrar em contato para confirmar os detalhes.",
      ok: "OK",
      required_fields: "Preencha os campos obrigatórios.",
      time_order: "O horário até deve ser depois do horário de.",
      send_fail: "Não foi possível enviar. Tente de novo.",
      explore: "Explorar",
      all_devices: "Todos os aparelhos",
      compare_specs: "Comparar fichas",
      your_account: "Sua conta",
      order_history: "Histórico de pedidos",
      log_out: "Sair",
      create_account: "Criar conta",
      connect: "Conectar",
      call_wa: "Ligar / WhatsApp",
      email_label: "E-mail",
      delivery: "Entrega",
      store: "Loja",
      reviews: "Avaliações de clientes",
      about: "Sobre nós",
      contact: "Contato",
      phones: "Celulares",
      tablets: "Tablets",
      laptops: "Notebooks",
      chargers: "Carregadores",
      accessories: "Acessórios",
      smart_watches: "Relógios inteligentes",
      ipads: "iPads",
      macbooks: "MacBooks",
      usb_cables: "Cabos USB",
      cases: "Capas",
      protectors: "Películas",
      earbuds: "Fones",
      skip_content: "Saltar para o conteúdo",
      back_to_top: "Voltar ao topo",
      phone_ph: "ex. 6484651",
      optional_ph: "Opcional",
      each: "cada",
      total: "Total",
      wa_kicker: "Alertas no WhatsApp",
      wa_heading: "Receba os preços primeiro.",
      wa_text: "Entre no grupo de WhatsApp da SMART FIX para preços antecipados, reposição e acesso antecipado às promoções.",
      wa_number: "Número do WhatsApp",
      wa_number_ph: "Número do WhatsApp, ex. 6484651",
      wa_confirm: "Confirmo que este é o meu número de WhatsApp",
      wa_error: "Digite um número de WhatsApp válido da Guiana e marque a confirmação.",
      wa_join: "Entrar no grupo"
    },
    zh: {
      home: "首页",
      close: "关闭",
      open_menu: "打开菜单",
      close_menu: "关闭菜单",
      login: "登录",
      account: "账户",
      cart: "购物车",
      search: "搜索",
      search_ph: "搜索型号或SKU",
      light: "浅色",
      dark: "深色",
      color_theme: "颜色主题",
      currency: "货币",
      language: "语言",
      compare: "对比",
      add_compare: "加入对比",
      add_cart: "加入购物车",
      buy_now: "立即购买",
      out_of_stock: "缺货",
      in_stock: "有货",
      low_stock: "库存紧张",
      sale: "特价",
      save: "节省",
      was: "原价",
      now: "现价",
      you_save: "您节省",
      unavailable: "不可用",
      product_type: "产品类型",
      brand: "品牌",
      model: "型号",
      storage: "存储",
      sort_price: "排序",
      price_range: "价格区间",
      all_types: "全部类型",
      all_brands: "全部品牌",
      all_models: "全部型号",
      all_storage: "全部存储",
      featured: "精选",
      low_high: "价格：从低到高",
      high_low: "价格：从高到低",
      name_az: "名称：A 到 Z",
      name_za: "名称：Z 到 A",
      min: "最低",
      max: "最高",
      filter_search_ph: "搜索类型、品牌、型号或存储",
      in_stock_only: "仅显示有货",
      clear: "清除",
      no_match: "没有符合这些筛选的产品。",
      matching: "匹配的产品",
      similar: "相似设备",
      your_details: "您的资料",
      first_name: "名",
      last_name: "姓",
      phone: "电话",
      email: "邮箱",
      optional: "可选",
      home_address: "收据用家庭地址",
      need_delivery: "需要配送吗？",
      yes: "是",
      no: "否",
      same_address: "配送地址与家庭地址相同吗？",
      delivery_address: "配送地址",
      same_receiver: "收件人是您本人吗？",
      receiver_first: "收件人名",
      receiver_last: "收件人姓",
      receiver_phone: "收件人电话",
      delivery_date: "配送日期",
      time_from: "可收货开始",
      time_to: "可收货结束",
      payment: "付款方式",
      cash: "货到付款",
      mmg: "MMG",
      notes: "其他说明",
      notes_ph: "可选 — 地标、门的颜色、首选联系方式",
      complete_order: "完成订单",
      send: "发送",
      sending: "发送中…",
      cancel: "取消",
      thanks_title: "感谢您的订单",
      thanks_copy: "我们会联系您确认订单详情。",
      ok: "好的",
      required_fields: "请填写必填项。",
      time_order: "结束时间必须晚于开始时间。",
      send_fail: "暂时无法发送，请再试一次。",
      explore: "浏览",
      all_devices: "全部产品",
      compare_specs: "对比规格",
      your_account: "您的账户",
      order_history: "订单记录",
      log_out: "退出",
      create_account: "创建账户",
      connect: "联系我们",
      call_wa: "电话 / WhatsApp",
      email_label: "邮箱",
      delivery: "配送",
      store: "门店",
      reviews: "客户评价",
      about: "关于我们",
      contact: "联系",
      phones: "手机",
      tablets: "平板",
      laptops: "笔记本",
      chargers: "充电器",
      accessories: "配件",
      smart_watches: "智能手表",
      ipads: "iPad",
      macbooks: "MacBook",
      usb_cables: "USB线",
      cases: "保护壳",
      protectors: "贴膜",
      earbuds: "耳机",
      skip_content: "跳到内容",
      back_to_top: "回到顶部",
      phone_ph: "例如 6484651",
      optional_ph: "选填",
      each: "每件",
      total: "合计",
      wa_kicker: "WhatsApp 提醒",
      wa_heading: "最先看到价格。",
      wa_text: "加入 SMART FIX WhatsApp 群，提前获取价格、补货和促销。",
      wa_number: "WhatsApp 号码",
      wa_number_ph: "WhatsApp 号码，例如 6484651",
      wa_confirm: "我确认这是我的 WhatsApp 号码",
      wa_error: "请输入有效的圭亚那 WhatsApp 号码并勾选确认。",
      wa_join: "加入群组"
    }
  };

  const NAV = {
    home: "home",
    "customers reviews": "reviews",
    "customers review": "reviews",
    "customer reviews": "reviews",
    "about us": "about",
    about: "about",
    contact: "contact",
    compare: "compare",
    login: "login",
    account: "account",
    "all devices": "all_devices",
    "compare specs": "compare_specs",
    search: "search",
    "create account": "create_account",
    "order history": "order_history",
    "log out": "log_out",
    explore: "explore",
    "your account": "your_account",
    connect: "connect",
    tablets: "tablets",
    tablet: "tablets",
    laptop: "laptops",
    laptops: "laptops",
    chargers: "chargers",
    phones: "phones",
    accessories: "accessories"
  };

  const KEY = "sf-lang";
  const langs = ["en", "es", "pt", "zh"];

  const read = () => {
    try {
      const stored = localStorage.getItem(KEY);
      if (langs.includes(stored)) return stored;
    } catch (e) {}
    return "en";
  };

  let lang = read();

  const t = (key) => (PACKS[lang] && PACKS[lang][key]) || PACKS.en[key] || key;

  const applyText = () => {
    document.documentElement.lang = lang === "pt" ? "pt-BR" : lang === "zh" ? "zh-CN" : lang;
    document.querySelectorAll("[data-i18n]").forEach((el) => {
      const key = el.getAttribute("data-i18n");
      if (key) el.textContent = t(key);
    });
    document.querySelectorAll("[data-i18n-html]").forEach((el) => {
      const key = el.getAttribute("data-i18n-html");
      if (key) el.innerHTML = t(key);
    });
    document.querySelectorAll("[data-i18n-placeholder]").forEach((el) => {
      const key = el.getAttribute("data-i18n-placeholder");
      if (key) el.setAttribute("placeholder", t(key));
    });
    document.querySelectorAll("[data-i18n-aria]").forEach((el) => {
      const key = el.getAttribute("data-i18n-aria");
      if (key) el.setAttribute("aria-label", t(key));
    });
    document.querySelectorAll("[data-i18n-nav]").forEach((el) => {
      const raw = (el.getAttribute("data-i18n-nav") || el.textContent || "").trim().toLowerCase();
      const key = NAV[raw];
      if (key) el.textContent = t(key);
    });
    document.querySelectorAll(".nav-list a, .footer a, .header-home").forEach((el) => {
      if (el.hasAttribute("data-i18n") || el.hasAttribute("data-i18n-nav")) return;
      const raw = (el.textContent || "").trim().toLowerCase();
      const key = NAV[raw];
      if (key) {
        el.setAttribute("data-i18n-nav", raw);
        el.textContent = t(key);
      }
    });
    document.querySelectorAll(".badge-sold").forEach((el) => { el.textContent = t("out_of_stock"); });
    document.querySelectorAll(".badge-sale").forEach((el) => { el.textContent = t("sale"); });
    document.querySelectorAll(".badge-low").forEach((el) => { el.textContent = t("low_stock"); });
    document.querySelectorAll(".badge-save[data-cents]").forEach((el) => {
      const money = window.themeMoney ? window.themeMoney(el.dataset.cents) : el.textContent;
      el.textContent = `${t("save")} ${money}`;
    });
    document.querySelectorAll(".stock-note").forEach((el) => {
      if (el.classList.contains("stock-sold")) el.textContent = t("out_of_stock");
      else if (el.classList.contains("stock-ok")) el.textContent = t("in_stock");
      else el.textContent = t("low_stock");
    });
    document.querySelectorAll("[data-add-compare]").forEach((el) => {
      if (el.tagName === "BUTTON") el.textContent = t("add_compare");
    });
    document.querySelectorAll("[data-buy-now]").forEach((el) => {
      if (!el.disabled || el.textContent) el.textContent = t("buy_now");
    });
    document.querySelectorAll("[data-add-cart]").forEach((el) => {
      if (el.disabled) el.textContent = t("out_of_stock");
      else el.textContent = t("add_cart");
    });
    document.querySelectorAll("[data-lang-switch]").forEach((sel) => { sel.value = lang; });
    window.themePrefs?.paint?.();
  };

  const setLang = (next) => {
    if (!langs.includes(next)) next = "en";
    const prev = lang;
    lang = next;
    try { localStorage.setItem(KEY, lang); } catch (e) {}
    applyText();
    document.dispatchEvent(new CustomEvent("sf-lang", { detail: lang }));
    if (prev !== lang) {
      if (window.themeTranslate?.to) window.themeTranslate.to(lang);
      else location.reload();
    }
  };

  window.themeI18n = { t, lang: () => lang, set: setLang, apply: applyText, packs: PACKS };

  document.addEventListener("change", (event) => {
    const sel = event.target.closest("[data-lang-switch]");
    if (sel) setLang(sel.value);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyText);
  } else {
    applyText();
  }
})();
